import type { ProjectVersion } from "../API";
import {
  DynamicReferenceScope,
  getRenamedModDataFields,
} from "../helpers/modKeyReferenceRename";

export type ProjectReferenceRename = {
  oldKey: string;
  newKey: string;
  scope: DynamicReferenceScope;
};

/** Copy only changed nodes: ProjectVersion is held in an MST frozen value. */
export function applyProjectReferenceRenames(
  project: ProjectVersion,
  renames: readonly ProjectReferenceRename[]
): ProjectVersion {
  let changed = false;
  const videoParts = project.videoParts?.map((videoPart) => {
    let sceneChanged = false;
    const modsArr = videoPart.modsArr?.map((mod) => {
      let data;
      try {
        data = JSON.parse(mod.dataStr || "{}");
        if (
          !data ||
          typeof data !== "object" ||
          (data.dataKey != null && typeof data.dataKey !== "string") ||
          (data.liveControlKey != null &&
            typeof data.liveControlKey !== "string")
        )
          return mod;
      } catch {
        return mod;
      }
      let modChanged = false;
      for (const { oldKey, newKey, scope } of renames) {
        const updates = getRenamedModDataFields(data, oldKey, newKey, scope);
        if (Object.keys(updates).length) {
          data = { ...data, ...updates };
          modChanged = true;
        }
      }
      if (!modChanged) return mod;
      sceneChanged = true;
      return { ...mod, dataStr: JSON.stringify(data) };
    });
    if (!sceneChanged) return videoPart;
    changed = true;
    return { ...videoPart, modsArr };
  });
  return changed ? { ...project, videoParts } : project;
}
